import angular from 'angular';
import modalResponsable from './pqrs-responsable-modal/pqrs-responsable-modal.view.html';
import modalInnerModal from './pqrs-inner-modal/pqrs-inner-modal.view.html';
import modalDetailModal from './pqrs-detail-modal/pqrs-detail-modal.view.html';
import createPQRSModal from '../pqrs-form-modal/pqrs-form-modal.view.html';
let inject = [
  '$scope',
  'PqrsDetailService',
  '$state',
  '$rootScope',
  'SharedService',
  '$uibModal',
  '$timeout',
  '$window',
  'NgTableParams',
  '$stateParams'
];

class PqrsDetailController{
  constructor ($scope, PqrsDetailService, $state, $rootScope, SharedService, $uibModal, $timeout, $window, NgTableParams, $stateParams) {
    this.$state = $state;
    this.$scope = $scope;
    this.$timeout = $timeout;
    this.$stateParams = $stateParams;
    this.NgTableParams = NgTableParams;
    this.$rootScope = $rootScope;
    this.$window = $window;
    this.$uibModal = $uibModal;
    this.PqrsDetailService = PqrsDetailService;
    this.SharedService = SharedService;
    this.state = {};
    this.statuses = [];
    this.pqrsResponsableList = [
      {
        id : "158",
        nombre : "Encargado PQRS 2"
      },
      {
        id : "159",
        nombre : "adrian serna"
      }
    ];
    this.pqrs = null;
    this.reasignacion = null;
    this.changeStateSuccess = false;
    this.changeResponsableSuccess = false;

    this.pqrsResponseFormData = {};
    this.pqrsResponseFormData.attachFiles = [];
    this.pqrsResponseFormData.files = [];
    this.ext = {
      'image/jpg': 'jpg',
      'image/jpeg': 'jpg',
      // 'image/png': 'png',
      'application/pdf': 'pdf',
      // 'text/plain': 'txt',
      // 'application/msword': 'doc',
      // 'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'docx',
      // 'application/vnd.ms-excel': 'xls',
      // 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',
      // 'application/vnd.ms-powerpoint': 'ppt',
      // 'application/vnd.openxmlformats-officedocument.presentationml.presentation': 'pptx'
    };
    this.maxSize = 3145728;
    this.maxSizeError = false;
    this.totalSize = 0;

    this.isOffAlert = false;
  }

  $onInit(){
    this.getPQRSDetail();
  }

  copyFiles() {
    this.invalidExt = false;
    this.maxSizeError = false;
    let files = angular.copy(this.pqrsResponseFormData.attachFiles);
    let totalSize = 0;

    angular.forEach(files, (value, key) => {
      totalSize += parseInt(value.filesize);
    });

    if ((this.totalSize + totalSize) <= this.maxSize) {
      this.totalSize += totalSize;
      files.forEach(val => {
        if (!this.ext[val.filetype]) {
          this.invalidExt = true;
        } else {
          this.pqrsResponseFormData.files.push(val);
        }
      });
    }
    else {
      //console.log('Los archivos no deben exceder 3 MB');
      this.maxSizeError = true;
    }
    this.pqrsResponseFormData.attachFiles = [];
  }
  
  showModalFormPQRS () {
    let options = {
      globals : this.shCtrl.globals
    };
    let modalInstance = this.$uibModal.open({
      animation: true,
      static : true,
      template: createPQRSModal,
      keyboard : false,
      controller : 'PqrsFormModalController',
      controllerAs : 'mdCtrl',
      size: 'lg',
      resolve : {
        modalOptions : () => options
      }
    });
  }

  getPQRSDetail() {
    let userId = this.shCtrl.globals.currentUser.userId;
    this.PqrsDetailService.getPQRSDetail(userId, this.$stateParams.id).then(({data}) =>  {
      this.state.loading = false;
      this.state.loaded = true;
      this.reasignacion = Number(data.reasignacion);
      this.pqrs_due_date = data.pqrs_due_date;
      this.pqrs_due_date.tipo_tiempo = (this.pqrs_due_date.tipo_tiempo === 'Hours') ?
        'Hora(s)' : (this.pqrs_due_date.tipo_tiempo === 'Days') ?
          'Día(s)' : (this.pqrs_due_date.tipo_tiempo === 'Weeks') ?
            'Semana(s)' : (this.pqrs_due_date.tipo_tiempo === 'Months') ?
              'Mes(es)' : 'Año(s)';
      // this.isSupervisor = $rootScope.globals.currentUser.isSupervisor;
      let responsesChat = [];
      let responsesInner = [];
      data.pqrs.responses.forEach((val) => {
        if (val.markedAsInner) {
          responsesInner.push(val);
        } else {
          responsesChat.push(val);
        }
      });
      this.pqrs = data.pqrs;
      this.pqrs.responses = responsesChat;
      this.pqrs.reponsesInner = responsesInner;
      this.pqrs_responsable = data.pqrs_responsable;
      this.pqrs_responsableCopy = angular.copy(data.pqrs_responsable);
      //this.isSupervisor = this.pqrs.responsable;
      this.pqrs.stateId = Number(this.pqrs.stateId);
      this.pqrs.stateIdCopy = Number(this.pqrs.stateId);

      if (this.pqrs.stateId === 56 || this.pqrs.stateId === 3) {
        this.statuses = data.statuses.filter((val) => {
          return val.id === 3 || val.id === 56;
        });
      } else {
        this.statuses = data.statuses.slice(0,-1);
      }

    }).catch((error) => {
      this.state.loading = false;
      this.state.loaded = true;
      this.state.error = true;
    });
  }
  
  openModalInnerComments () {
    let modalInstance = this.$uibModal.open({
      animation: true,
      template: modalInnerModal,
      size: 'md',
      controller: 'PqrsInnerModalController',
      controllerAs: 'mdCtrl',
      resolve: {
        responses : () => this.pqrs.reponsesInner
      }
    });
    
    modalInstance.result.then(comment => {
      this.PqrsDetailService.changePQRSStatus(userId, this.pqrs.id, this.pqrs.stateId, comment).then(res => {
        this.changeStateSuccess = true;
        this.getPQRSDetail();
        this.$timeout(() => {
          this.changeStateSuccess = false;
        }, 3000)
      })
        .catch(err =>  {
          console.log(err);
        })
    }, () => {
      // $log.info('Modal dismissed at: ' + new Date());
      this.pqrs.stateId = this.pqrs.stateIdCopy;
    });
  }

  getPQRSResponsables(search) {
    return this.PqrsDetailService.getPQRSResponsables(search).then(({data}) => {
        this.state.loading = false;
        this.state.loaded = true;
        return data;
      }).
      catch((error) => {
        this.state.loading = false;
        this.state.loaded = true;
        this.state.error = true;
      });
  }

  savePQRSResponsable($item) {
    let userId = this.shCtrl.globals.currentUser.userId;
    let modalInstance = this.$uibModal.open({
      animation: true,
      template: modalResponsable,
      size: '',
      controller : 'PqrsResponsableModalController',
      controllerAs: 'mdCtrl'
    });

    modalInstance.result.then(comment => {
      this.PqrsDetailService.savePQRSResponsable(userId, this.$stateParams.id, $item.id, comment).then(response => {
        this.changeResponsableSuccess = true;
        this.state.loading = false;
        this.state.loaded = true;
        this.$timeout(() => {
          this.$state.go('home.pqrsList');
        }, 2000)
      }).catch(error => {
        this.changeResponsableSuccess = false;
        this.state.loading = false;
        this.state.loaded = true;
        this.state.error = true;
      });
    }, () => {
      // $log.info('Modal dismissed at: ' + new Date());
      this.pqrs_responsable = this.pqrs_responsableCopy;
    });

  }
  
  saveResponsePQRS(form) {
    if(!form.$valid) {
      angular.forEach(form.$error.required, field => { field.$setDirty(); });
    } else {
      this.pqrsResponseFormData.uploadFiles = angular.copy(this.pqrsResponseFormData.files);
      angular.forEach(this.pqrsResponseFormData.uploadFiles, (value, key) => {
        let fpath = value.filename.replace(/\\/g, '/');
        let fname = fpath.substring(fpath.lastIndexOf('/')+1, fpath.lastIndexOf('.'));
        this.pqrsResponseFormData.uploadFiles[key] = {
          base64: [
            value.filetype,
            fname,
            value.filesize,
            value.base64,
          ].join(";")
        };
      });
      
      this.pqrsResponseFormData.state = {};
      this.pqrsResponseFormData.state.savingPqrsResponse = true;
      this.$timeout(() => {
        let userId = this.shCtrl.globals.currentUser.userId;
        let markedAsResolved = 0;
        if(this.pqrsResponseFormData.markedAsResolved) { markedAsResolved = 1; }
        let markedAsInner = 0;
        if(this.pqrsResponseFormData.markedAsInner) { markedAsInner = 1; }
        let data = {
          responseText: this.pqrsResponseFormData.comments,
          markedAsResolved: markedAsResolved,
          markedAsInner : markedAsInner,
          uploadFiles: this.pqrsResponseFormData.uploadFiles
        };
        this.PqrsDetailService.savePQRSResponse(userId, this.pqrs.id, data)
          .then(pqrsResponse => {
            this.pqrsResponseFormData.attachFiles = [];
            this.pqrsResponseFormData.files = [];
            
            // this.pqrs.responses.unshift(pqrsResponse);
            // this.pqrs.isClosed = pqrsResponse.isClosed;
            this.getPQRSDetail();
            this.pqrsResponseFormData.comments = '';
            this.pqrsResponseForm.comments.$setPristine();
            
            this.pqrsResponseFormData.state.savingPqrsResponse = false;
            this.pqrsResponseFormData.state.savedPqrsResponse = true;
            this.$timeout(() => {
              this.pqrsResponseFormData.state.savedPqrsResponse = false;
            }, 2000)
          }).
        catch(errors => {
          console.log(JSON.stringify(errors));
          this.pqrsResponseFormData.state.savingPqrsResponse = false;
          this.pqrsResponseFormData.state.message = errors.message;
          this.pqrsResponseFormData.state.errors = errors.errors;
        });
      }, 500);
    }
  }

  changePQRSState () {
    let userId = this.shCtrl.globals.currentUser.userId;
    // Guardar info de cambio
    if (this.pqrs.stateId === 3 || this.pqrs.stateId === '3' ) {
      let modalInstance = this.$uibModal.open({
        animation: true,
        template: modalDetailModal,
        size: 'md',
        controller: 'PqrsDetailModalController',
        controllerAs: 'mdCtrl'
      });
      modalInstance.result.then((comment) => {

        this.PqrsDetailService.changePQRSStatus(userId, this.pqrs.id, this.pqrs.stateId, comment).then((res) => {
          //console.log(res);
          this.changeStateSuccess = true;
          this.getPQRSDetail();
          this.$timeout(() => {
            this.changeStateSuccess = false;
          }, 3000)
        })
          .catch((err) => {
            console.log(err);
          })
      }, () => {
        // $log.info('Modal dismissed at: ' + new Date());
        this.pqrs.stateId = this.pqrs.stateIdCopy;
      });
    } else {
      this.PqrsDetailService.changePQRSStatus(userId, this.pqrs.id, this.pqrs.stateId).then((res) => {
        //console.log(res);
        this.changeStateSuccess = true;
        this.getPQRSDetail();
        this.$timeout(() => {
          this.changeStateSuccess = false;
        }, 3000)
      });
    }
    // pqrsService.changePQRSStatus(this.pqrs.id, this.pqrs.stateId).then(function (res) {
    //   console.log(res);
    //   this.changeStateSuccess = true;
    //   getPQRSDetail();
    //   $timeout(function () {
    //     this.changeStateSuccess = false;
    //   }, 3000)
    // })
    //   .catch(function (err) {
    //     console.log(err);
    //   })

  }

  offAlert() {
    //console.log('sin alerta');
    this.isOffAlert = true;
  }

  removeFile(file) {
    this.invalidExt = false;
    this.maxSizeError = false;
    let index = this.pqrsResponseFormData.files.indexOf(file);

    if (index > -1) {
      this.totalSize = this.totalSize - this.pqrsResponseFormData.files[index].filesize;
      this.pqrsResponseFormData.files.splice(index, 1);
    }
  }

  messageResponse (options, callAcept, callback, callCancel, callbackCancel) {
    let modalInstance = this.$uibModal.open({
      animation: true,
      template: modalConfirmation,
      controller : 'ModalResponseController',
      controllerAs : 'mdCtrl',
      size: options.size,
      resolve : {
        modalOptions : () => options
      }
    });
    modalInstance.result.then(() => {
      if(callAcept) {
        callback();
      }
    }).catch(reason => {
      if(callCancel) {
        callbackCancel();
      }
    });
  }
}

PqrsDetailController.$inject = inject;

export default PqrsDetailController;




/** WEBPACK FOOTER **
 ** C:/Users/dares/Documents/SIESA_repositorios/himalaya/www/components/pqrs/pqrs-detail/pqrs-detail.controller.js
 **/